import React from 'react';
import styles from './css/index.module.css';
import { Input, Textarea } from '@fluentui/react-components';
import { Delete20Regular } from '@fluentui/react-icons';
import { validExtensions } from '../../utils/misc';
import { PatchProjectData } from '../../redux/projectDataSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
const AddOrganisationDetail = ({ setSelectedView, createdProjectData }) => {
    const dispatch = useDispatch();
    const { projectDetailButtonLoading } = useSelector(state => state.projectData);
    const [formData, setFormData] = React.useState({
        sector: '',
        established_year: '',
        description: '',
        employees: '',
        company_size: '',
    });
    const handleChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleSubmit = async () => {
        await dispatch(
            PatchProjectData({
                data: {
                    sector: formData?.sector,
                    established_year: formData?.established_year,
                    description: formData?.description,
                    employees: formData?.employees,
                    company_size: formData?.company_size,
                },
                id: createdProjectData?.id,
            }),
        );

        setSelectedView('brandDetails');
    };

    React.useEffect(() => {
        if (createdProjectData) {
            setFormData({
                sector: createdProjectData?.sector,
                established_year: createdProjectData?.established_year,
                description: createdProjectData?.description,
                company_size: createdProjectData?.company_size,
                employees: createdProjectData?.employees,
            });
        }
    }, [createdProjectData]);

    return (
        <div className={styles.componentCard}>
            <h5 className={styles.componentTitle}>Confirm organisation details</h5>
            <div>
                <div className="mb-4">
                    <p className={styles.fieldLabel}>Sector</p>
                    <Input placeholder="Add Company Sector" className={styles.inputField} value={formData?.sector} onChange={handleChange} name="sector" />
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <div className="mb-4">
                            <p className={styles.fieldLabel}>Company size</p>
                            <Input className={styles.inputField} placeholder="1-1000" value={formData?.company_size} onChange={handleChange} name="company_size" />
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="mb-4">
                            <p className={styles.fieldLabel}>Number of employees</p>
                            <Input className={styles.inputField} placeholder="0" value={formData?.employees} onChange={handleChange} name="employees" />
                        </div>
                    </div>
                </div>
                <div className="mb-4">
                    <p className={styles.fieldLabel}>About the company</p>
                    <Textarea
                        placeholder="Add company description, services offered, etc."
                        rows={6}
                        className={styles.textareaField}
                        value={formData?.description}
                        onChange={handleChange}
                        name="description"
                    />
                </div>
                <div className="mb-4 w-50">
                    <p className={styles.fieldLabel}>Year of establishment</p>
                    <Input className={styles.inputField} value={formData?.established_year} onChange={handleChange} name="established_year" />
                </div>
                <button onClick={handleSubmit} className={styles.submitButton}>
                    Confirm {projectDetailButtonLoading && <AiOutlineLoading3Quarters className="ms-2 rotateLoader" />}
                </button>
            </div>
        </div>
    );
};

export default AddOrganisationDetail;
